/* globals gapi, FB */

import auth from '../service/auth';
import * as profileApi from '../service/profile';

export default function( $, app ) {
	var { model: session, profile } = app;

	var $body = $( 'body' );
	var $logout = $( '.button-logout' );

	app.on( 'login', () => {
		$body.addClass( 'loggedin' );
	} );

	app.on( 'logout', () => {
		$body.removeClass( 'loggedin' );
		session.set( 'uid', null );
	} );

	$logout.click( () => app.trigger( 'logout' ) );

	function handleLogin( result, form ) {
		flutterDebug( 'login', result );
		if ( result.status === 'ERROR' ) {
			return alert( result.message || result.description || 'Unknown error' );
		}

		app.trigger( 'login' );

		app.id = result.uid;
		session.set( 'uid', app.id );

		profileApi.load( app.id, data => {
			profile.set( data );
			flutterDebug( 'profile', data );
		} );

		$( form )[0].reset();
	}

	// =========================
	// ! Form Basics
	// =========================

	var $forms = $( '.account-modal' );

	$forms
	.submit( function( e ) {
		e.preventDefault();
		$( this ).addClass( 'waiting' );
	} )
	.on( 'input', function() {
		var filled = 0,
			fillable = 0;

		$( this ).find( 'input' ).each( function() {
			if ( this.required ) {
				fillable++;
			}
			if ( this.value !== '' ) {
				filled++;
			}
		} );

		fillable = Math.max( fillable, 1 );

		$( this ).find( '.button-submit' ).attr( 'disabled', filled < fillable );
	} );

	// =========================
	// ! OAuth Login Handling
	// =========================

	function google() {
		var loggedIn = false;

		gapi.load( 'auth2', () => {
			var gAuth = gapi.auth2.init( {
				client_id: '658561976207-m19q17ne9iv6knjegtkod48m9irgfd4v.apps.googleusercontent.com',
				cookiepolicy: 'single_host_origin',
				scope: 'profile',
			} );

			$( '.signin-google' ).each( function() {
				gAuth.attachClickHandler(
					this,
					{
						scope: 'profile email',
					},
					user => {
						loggedIn = true;

						flutterDebug( 'google', user.getAuthResponse() );

						auth( 'oauth', {
							id_token: user.getAuthResponse().id_token,
							userType: 'google',
						}, resp => handleLogin( resp, '#login' ) );
					},
					error => {
						flutterDebug( 'google', error );
					}
				);
			} );
		} );

		$logout.click( () => {
			if ( ! loggedIn ) {
				return;
			}

			gapi.auth2.getAuthInstance().signOut();

			loggedIn = false;
		} );
	}

	function facebook() {
		var loggedIn = false;

		FB.init( {
			appId: '2227239580717749',
			cookie: true,
			xfbml: true,
			version: 'v4.0',
		} );

		function processLogin( resp ) {
			if ( resp.status === 'connected' ) {
				loggedIn = true;

				flutterDebug( 'facebook', resp );

				auth( 'oauth', {
					id_token: resp.accessToken,
					userType: 'facebook',
				}, resp => handleLogin( resp, '#login' ) );
			}
		}

		function checkLoginState() {
			FB.getLoginStatus( processLogin );
		}

		$( '.signin-facebook' ).click( () => {
			FB.login( processLogin, { scope: 'public_profile,email,user_age_range,user_gender,user_location' } );
		} );

		$logout.click( () => {
			if ( ! loggedIn ) {
				return;
			}

			FB.logout();

			loggedIn = false;
		} );

		checkLoginState();
	}

	// =========================
	// ! Manual Login Handling
	// =========================

	var $login = $( '#login' );
	var $register = $( '#register' );

	$login.submit( function() {
		auth( 'login', {
			email: document.getElementById( 'login_email' ).value,
			password: document.getElementById( 'login_password' ).value,
			userType: 'local',
		}, resp => {
			$login.removeClass( 'waiting' );
			handleLogin( resp, this );
		} );
	} );

	$register.submit( function() {
		var password = document.getElementById( 'register_password1' );
		var confirmPassword = document.getElementById( 'register_password2' );

		if ( ! password.value ) {
			return alert( 'Please enter a password.' );
		}
		if ( password.value !== confirmPassword.value ) {
			return alert( 'Passwords do not match.' );
		}

		auth( 'register', {
			email: document.getElementById( 'register_email' ).value,
			password: password.value,
			userType: 'local',
		}, resp => {
			$register.removeClass( 'waiting' );
			handleLogin( resp, this );
		} );
	} );

	// =========================
	// ! Account Management
	// =========================

	var $profile = $( '#profile' );
	var $account = $( '#account' );
	var $recover = $( '#recover' );

	$profile
	.on( 'showing', function() {
		$profile.find( 'input' ).each( function() {
			var name = this.name;
			if ( this.name.indexOf( '[]' ) > 0 ) {
				name = name.replace( '[]', '' );
				this.checked = ( profile.get( name ) || [] ).indexOf( this.value ) >= 0;
			} else {
				this.value = profile.get( name ) || '';
			}
		} );

		$profile.find( '.-toggle' ).trigger( 'input' );
	} )
	.submit( function() {
		var data = {};
		$profile.find( 'input' ).each( function() {
			var name = this.name;
			var value = this.value;
			if ( this.name.indexOf( '[]' ) >= 0 ) {
				name = name.replace( '[]', '' );
				value = data[ name ] || [];
				if ( this.checked ) {
					value.push( this.value );
				}
			}
			profile.set( name, data[ name ] = value );
		} );

		profileApi.save( app.id, data, result => {
			$profile.removeClass( 'waiting' );

			if ( result.status === 'ERROR' ) {
				return alert( result.description );
			}

			history.back();
		} );
	} );

	$account
	.submit( function() {
		var oldPassword = document.getElementById( 'account_password0' );
		var newPassword = document.getElementById( 'account_password1' );
		var confirmPassword = document.getElementById( 'account_password2' );

		if ( ! newPassword.value ) {
			return alert( 'Please enter a new password.' );
		}
		if ( newPassword.value !== confirmPassword.value ) {
			return alert( 'Passwords do not match.' );
		}

		auth( 'password', {
			uid: app.id,
			oldPassword: oldPassword.value,
			newPassword: newPassword.value,
		}, result => {
			$account.removeClass( 'waiting' );

			if ( result.status === 'ERROR' ) {
				return alert( result.description );
			}

			history.back();
			this.reset();
		} );
	} );

	$recover
	.submit( function() {
		var email = document.getElementById( 'recover_email' ).value;

		auth( 'recover', { email }, result => {
			$recover.removeClass( 'waiting' );

			if ( result.status === 'ERROR' ) {
				return alert( result.description );
			}

			alert( result.message );

			history.back();
			this.reset();
		} );
	} );

	return { google, facebook };
}
